import clone from 'lodash/clone';
import PropTypes from 'prop-types';
import Dragula from 'react-dragula';
import React, { Component } from 'react';
import { ControlPanelSteps } from '@upstart/harmony/lib/flow-utils';
import FlowListItem from './FlowListItem';
import './styles.scss';

const findDOMIndex = (el, container) =>
  Array.from(container.children).indexOf(el);

const move = (array, from, to) => array.splice(to, 0, array.splice(from, 1)[0]);

class FlowList extends Component {
  dragulaDecorator = (component) => {
    const { flowListType } = this.props;
    // Keep track of the last dragging index to do some reordering.
    let dragIndex;

    // Use dragula on the container to make its children draggable
    Dragula([component], {
      invalid(el) {
        // locked elements cannot be moved
        return el.getAttribute('data-locked');
      },
      accepts(el, target, source, sibling) {
        const id = sibling ? sibling.getAttribute('data-id') : null;
        let step = {};
        // CHECK IF THIS STEP IS LOCKED
        if (id) {
          for (const prop in ControlPanelSteps[flowListType]) {
            if (ControlPanelSteps[flowListType][prop].id === id) {
              step = ControlPanelSteps[flowListType][prop];
            }
          }
        }
        // ONLY ALLOW THE DRAG IF THE STEP IS NOT LOCKED
        return !step.locked;
      },
    })
      // When we drag an item, memorize its index.
      .on('drag', (el, source) => {
        dragIndex = findDOMIndex(el, source);
      })

      // When we drop an item, reorder the array
      .on('drop', (el, target) => {
        const flow = clone(this.props.flow);
        move(flow, dragIndex, findDOMIndex(el, target));
        this.props.onChange(flowListType, flow);
      });
  };

  renderItem = (item, flowListType) => (
    <FlowListItem
      item={item}
      key={item.id}
      flow={this.props.flow}
      onChange={this.props.onChange}
      flowListType={flowListType}
    />
  );

  render() {
    const { flow, dealer, flowListType } = this.props;
    return (
      <div className="draggable-container">
        <div className="draggable-container-title">{dealer.name} Flow</div>
        <div className="draggable-list" ref={this.dragulaDecorator}>
          {flow && flow.map((config) => this.renderItem(config, flowListType))}
        </div>
      </div>
    );
  }
}

FlowList.propTypes = {
  flow: PropTypes.array,
  flowListType: PropTypes.string,
  dealer: PropTypes.object,
  onChange: PropTypes.func,
};

export default FlowList;
